@if (templateLoading()) {
  <mat-progress-spinner [diameter]="20" color="accent" mode="indeterminate" />
} @else {
  <span>{{ $safeNavigationMigration(emailTemplate()?.name) | infoDisplay }}</span>
}
